export interface SaintTropezResidence {
  slug: string;
  name: string;
  location: string;
  image: string;
  images: string[];
  bedrooms: string;
  bathrooms: string;
  guests: string;
  pools: string;
  features: string[];
  pricing: {
    low: string;
    high: string;
  };
  priceNote: string;
  description: string;
  highlights: string[];
  distances: { place: string; time: string }[];
}

export const saintTropezResidences: SaintTropezResidence[] = [
  {
    slug: "villa-lava",
    name: "Villa Lava",
    location: "Les Parcs de Saint-Tropez",
    image: "https://cdn.prod.website-files.com/65c909f4325d487977a8cb32/68ebf068eb66973be6d288c5_1-CS-Villas_Villa-Lava_Terrace_3.avif",
    images: [
      "https://cdn.prod.website-files.com/65c909f4325d487977a8cb32/68ebf068eb66973be6d288c5_1-CS-Villas_Villa-Lava_Terrace_3.avif",
      "https://cdn.prod.website-files.com/65c909f4325d487977a8cb32/68ebf069eb66973be6d288d4_2-CS-Villas_Villa-Lava_View_1.avif",
      "https://cdn.prod.website-files.com/65c909f4325d487977a8cb32/68ebf069eb66973be6d288e0_3-CS-Villas_Villa-Lava_Swimming-Pool_1.avif",
      "https://cdn.prod.website-files.com/65c909f4325d487977a8cb32/68ebf069eb66973be6d288dd_4-CS-Villas_Villa-Lava_Swimming-Pool_6.avif",
      "https://cdn.prod.website-files.com/65c909f4325d487977a8cb32/68ebf068eb66973be6d288c8_5-CS-Villas_Villa-Lava_Swimming-Pool_7.avif",
      "https://cdn.prod.website-files.com/65c909f4325d487977a8cb32/68ebf069eb66973be6d288da_6-CS-Villas_Villa-Lava_Swimming-Pool_4.avif",
    ],
    bedrooms: "9",
    bathrooms: "9",
    guests: "Up to 18",
    pools: "1",
    features: [
      "Heated swimming pool",
      "Lush private gardens",
      "Al fresco dining terrace",
      "Air conditioning throughout",
      "Fully equipped kitchen",
      "Sea views",
      "Private parking",
      "Outdoor lounge areas",
      "BBQ area",
      "Security system",
    ],
    pricing: {
      low: "€35.000",
      high: "€70.000",
    },
    priceNote: "Prices per week. Minimum stay applies during high season.",
    description:
      "Nestled within the exclusive Les Parcs de Saint-Tropez, Villa Lava is a grand estate offering nine luxurious bedrooms, each with en-suite bathrooms. This exceptional property combines Provençal charm with modern luxury, set within private landscaped gardens.\n\nThe villa features expansive living and dining areas that flow effortlessly onto sun-drenched terraces, a heated swimming pool surrounded by Mediterranean flora, and multiple outdoor lounging areas perfect for long summer days.\n\nLes Parcs de Saint-Tropez is one of the most prestigious residential enclaves on the Riviera, offering direct access to secluded beaches while remaining just minutes from the vibrant port and Place des Lices.",
    highlights: [
      "Prestigious Les Parcs de Saint-Tropez location",
      "Nine en-suite bedrooms for large groups",
      "Heated pool surrounded by private gardens",
      "Minutes from Saint-Tropez port and beaches",
    ],
    distances: [
      { place: "Place des Lices", time: "5 min drive" },
      { place: "Pampelonne Beach", time: "10 min drive" },
      { place: "Port of Saint-Tropez", time: "5 min drive" },
      { place: "Nice Airport", time: "90 min drive" },
    ],
  },
  {
    slug: "villa-patch",
    name: "Villa Patch",
    location: "Boulevard Patch, Saint-Tropez",
    image: "https://cdn.prod.website-files.com/65c909f4325d487977a8cb32/68ebf05ff52b293ce252fefa_1-Saint%2525252525252BTropez_CS-Villas_Villa-Patch_pool.avif",
    images: [
      "https://cdn.prod.website-files.com/65c909f4325d487977a8cb32/68ebf05ff52b293ce252fefa_1-Saint%2525252525252BTropez_CS-Villas_Villa-Patch_pool.avif",
      "https://cdn.prod.website-files.com/65c909f4325d487977a8cb32/68ebf060f52b293ce252ff19_2-Saint%2BTropez_CS-Villas_Villa-Patch_outdoor1.avif",
      "https://cdn.prod.website-files.com/65c909f4325d487977a8cb32/68ebf062f52b293ce252ff5b_3-Saint%2BTropez_CS-Villas_Villa-Patch_outdoor2.avif",
      "https://cdn.prod.website-files.com/65c909f4325d487977a8cb32/68ebf062f52b293ce252ff4c_4-Saint%2BTropez_CS-Villas_Villa-Patch_outdoor3.avif",
      "https://cdn.prod.website-files.com/65c909f4325d487977a8cb32/68ebf062f52b293ce252ff61_5-Saint%2BTropez_CS-Villas_Villa-Patch_outdoor%2Bkitchen.avif",
      "https://cdn.prod.website-files.com/65c909f4325d487977a8cb32/68ebf05ff52b293ce252ff0a_6-Saint%2BTropez_CS-Villas_Villa-Patch_living%2Broom1.avif",
    ],
    bedrooms: "5",
    bathrooms: "6",
    guests: "Up to 10",
    pools: "1",
    features: [
      "Infinity pool",
      "Panoramic sea views",
      "Open-plan living",
      "Designer interiors",
      "Air conditioning throughout",
      "Fully equipped kitchen",
      "Outdoor dining area",
      "Sun terrace",
      "Private parking",
      "Landscaped garden",
    ],
    pricing: {
      low: "€20.000",
      high: "€45.000",
    },
    priceNote: "Prices per week. Minimum stay applies during high season.",
    description:
      "Situated along the prestigious Boulevard Patch in Saint-Tropez, this contemporary villa offers five elegant bedrooms with six bathrooms, blending modern architecture with the relaxed sophistication of the French Riviera.\n\nFloor-to-ceiling windows frame panoramic views of the Mediterranean, while the infinity pool appears to merge with the sea beyond. The open-plan living spaces are finished with designer furnishings and flow seamlessly to outdoor terraces ideal for entertaining.\n\nThe villa's prime location provides easy access to both the glamour of Saint-Tropez centre and the tranquillity of the Riviera's most beautiful coastal paths.",
    highlights: [
      "Stunning infinity pool with sea views",
      "Contemporary architecture with designer interiors",
      "Prime Boulevard Patch location",
      "Walking distance to Saint-Tropez centre",
    ],
    distances: [
      { place: "Place des Lices", time: "5 min walk" },
      { place: "Port of Saint-Tropez", time: "8 min walk" },
      { place: "Pampelonne Beach", time: "10 min drive" },
      { place: "Nice Airport", time: "90 min drive" },
    ],
  },
  {
    slug: "villa-calma",
    name: "Villa Calma",
    location: "Canebiers, Saint-Tropez",
    image: "https://cdn.prod.website-files.com/65c909f4325d487977a8cb32/69cd3c4b2b5c2d6052b5c4e2_aurelienstudio-cs-villas-39.jpg",
    images: [
      "https://cdn.prod.website-files.com/65c909f4325d487977a8cb32/69cd3c4b2b5c2d6052b5c4e2_aurelienstudio-cs-villas-39.jpg",
      "https://cdn.prod.website-files.com/65c909f4325d487977a8cb32/69cd3c5c0985f55b61e6202f_aurelienstudio-cs-villas-17.jpg",
      "https://cdn.prod.website-files.com/65c909f4325d487977a8cb32/69cd3c757aff8d36afb30eeb_aurelienstudio-cs-villas-24.jpg",
      "https://cdn.prod.website-files.com/65c909f4325d487977a8cb32/69cd3c9be87adb16b1a5e082_aurelienstudio-cs-villas-15.jpg",
      "https://cdn.prod.website-files.com/65c909f4325d487977a8cb32/69cd3c67b077aee00ef2a1d2_aurelienstudio-cs-villas-21.jpg",
      "https://cdn.prod.website-files.com/65c909f4325d487977a8cb32/69cd3d7ac3a96d5470b07e0d_aurelienstudio-cs-villas-26.jpg",
    ],
    bedrooms: "5",
    bathrooms: "5",
    guests: "Up to 10",
    pools: "1",
    features: [
      "Heated swimming pool",
      "Private beach access nearby",
      "Provençal architecture",
      "Air conditioning throughout",
      "Fully equipped kitchen",
      "Outdoor shower",
      "Pétanque court",
      "Olive grove garden",
      "BBQ & outdoor kitchen",
      "Covered terrace",
    ],
    pricing: {
      low: "€18.000",
      high: "€40.000",
    },
    priceNote: "Prices per week. Minimum stay applies during high season.",
    description:
      "Villa Calma is a beautifully restored Provençal estate in the sought-after Canebiers neighbourhood of Saint-Tropez, one of the most exclusive residential areas on the peninsula. Five en-suite bedrooms are spread across the main house and guest quarters.\n\nThe grounds feature a heated swimming pool, an olive grove garden, a pétanque court, and a covered terrace with outdoor kitchen — all designed for the unhurried pace of Riviera living. The interiors blend rustic Provençal charm with contemporary comfort.\n\nCanebiers is known for its proximity to the iconic Plage des Canebiers and offers a peaceful retreat just minutes from the centre of Saint-Tropez.",
    highlights: [
      "Exclusive Canebiers neighbourhood",
      "Authentic Provençal character with modern comfort",
      "Near Plage des Canebiers",
      "Private, peaceful grounds with olive grove",
    ],
    distances: [
      { place: "Plage des Canebiers", time: "5 min walk" },
      { place: "Place des Lices", time: "10 min drive" },
      { place: "Pampelonne Beach", time: "15 min drive" },
      { place: "Nice Airport", time: "90 min drive" },
    ],
  },
  {
    slug: "villa-riyu",
    name: "Villa Riyu",
    location: "Malleribes, Gassin",
    image: "https://cdn.prod.website-files.com/65c909f4325d487977a8cb32/68ebf07a0a31780da5956adb_1-Saint%25252525252BTropez%25252525252BCS-Villas_Villa-Lessing_Swimming-Pool_2_R.avif",
    images: [
      "https://cdn.prod.website-files.com/65c909f4325d487977a8cb32/68ebf07a0a31780da5956adb_1-Saint%25252525252BTropez%25252525252BCS-Villas_Villa-Lessing_Swimming-Pool_2_R.avif",
      "https://cdn.prod.website-files.com/65c909f4325d487977a8cb32/68ebf0780a31780da5956aa7_2-Saint%2BTropez%2BCS-Villas_Villa-Lessing_Swimming-Pool_1_R.avif",
      "https://cdn.prod.website-files.com/65c909f4325d487977a8cb32/68ebf0780a31780da5956a90_3-Saint%2BTropez%2BCS-Villas_Villa-Lessing_Swimming-Pool_3_R.avif",
      "https://cdn.prod.website-files.com/65c909f4325d487977a8cb32/68ebf0780a31780da5956a9e_4-Saint%2BTropez%2BCS-Villas_Villa-Lessing_Garden_1_R.avif",
      "https://cdn.prod.website-files.com/65c909f4325d487977a8cb32/68ebf07a0a31780da5956ad6_5-Saint%2BTropez%2BCS-Villas_Villa-Lessing_Terrace_1_R.avif",
      "https://cdn.prod.website-files.com/65c909f4325d487977a8cb32/68ebf0780a31780da5956aa1_6-Saint%2BTropez%2BCS-Villas_Villa-Lessing_Living-Room_2_R.avif",
    ],
    bedrooms: "7",
    bathrooms: "7",
    guests: "Up to 14",
    pools: "1",
    features: [
      "Large heated pool",
      "Panoramic Gulf of Saint-Tropez views",
      "Home cinema",
      "Fitness room",
      "Wine cellar",
      "Air conditioning throughout",
      "Fully equipped kitchen",
      "Outdoor kitchen & BBQ",
      "Pool house",
      "Landscaped grounds",
    ],
    pricing: {
      low: "€25.000",
      high: "€55.000",
    },
    priceNote: "Prices per week. Minimum stay applies during high season.",
    description:
      "Perched in the hills of Gassin with sweeping views over the Gulf of Saint-Tropez, Villa Riyu is a modern masterpiece offering seven en-suite bedrooms across a generous estate. The property seamlessly blends indoor and outdoor living with floor-to-ceiling glass and expansive terraces.\n\nAmenities include a state-of-the-art home cinema, fitness room, wine cellar, and a pool house alongside the large heated swimming pool. The outdoor kitchen and BBQ area make it ideal for hosting memorable gatherings under the Provençal sky.\n\nGassin, a medieval hilltop village, provides a serene and private setting while remaining close to the beaches and nightlife of Saint-Tropez and Ramatuelle.",
    highlights: [
      "Panoramic Gulf of Saint-Tropez views",
      "Seven en-suite bedrooms for large parties",
      "Cinema, gym, and wine cellar",
      "Hilltop Gassin setting with total privacy",
    ],
    distances: [
      { place: "Pampelonne Beach", time: "8 min drive" },
      { place: "Saint-Tropez Centre", time: "10 min drive" },
      { place: "Gassin Village", time: "3 min drive" },
      { place: "Nice Airport", time: "85 min drive" },
    ],
  },
  {
    slug: "villa-texas",
    name: "Villa Texas",
    location: "L'Escalet, Ramatuelle",
    image: "https://cdn.prod.website-files.com/65c909f4325d487977a8cb32/68ebf0736425a7bd16d3c46b_1-Saint%252BTropez%252BCS-Villas_Villa-Texas_Sky-View_1_N.avif",
    images: [
      "https://cdn.prod.website-files.com/65c909f4325d487977a8cb32/68ebf0736425a7bd16d3c46b_1-Saint%252BTropez%252BCS-Villas_Villa-Texas_Sky-View_1_N.avif",
      "https://cdn.prod.website-files.com/65c909f4325d487977a8cb32/68ebf0736425a7bd16d3c468_2-Saint%2BTropez%2BCS-Villas_Villa-Texas_Swimming-Pool_2_R.avif",
      "https://cdn.prod.website-files.com/65c909f4325d487977a8cb32/68ebf0736425a7bd16d3c46e_3-Saint%2BTropez%2BCS-Villas_Villa-Texas_Sky-View_2_R.avif",
      "https://cdn.prod.website-files.com/65c909f4325d487977a8cb32/68ebf0736425a7bd16d3c48c_4-Saint%2BTropez%2BCS-Villas_Villa-Texas_Swimming-Pool_1_R.avif",
      "https://cdn.prod.website-files.com/65c909f4325d487977a8cb32/68ebf0756425a7bd16d3c4ea_5-Saint%2BTropez%2BCS-Villas_Villa-Texas_Petanque_1_R.avif",
      "https://cdn.prod.website-files.com/65c909f4325d487977a8cb32/68ebf0736425a7bd16d3c47f_6-Saint%2BTropez%2BCS-Villas_Villa-Texas_Terrace_2_R.avif",
    ],
    bedrooms: "5",
    bathrooms: "5",
    guests: "Up to 10",
    pools: "1",
    features: [
      "Heated pool",
      "Sea views",
      "Outdoor dining terrace",
      "Air conditioning throughout",
      "Fully equipped kitchen",
      "Mediterranean garden",
      "Sun loungers",
      "BBQ area",
      "Private parking",
      "Quiet residential area",
    ],
    pricing: {
      low: "€20.000",
      high: "€45.000",
    },
    priceNote: "Prices per week. Minimum stay applies during high season.",
    description:
      "Villa Texas occupies a privileged position in L'Escalet, Ramatuelle — one of the most pristine and unspoilt coastal areas near Saint-Tropez. Five bedrooms with en-suite bathrooms are arranged to offer sea views and complete privacy.\n\nThe outdoor spaces are the heart of this property: a heated pool surrounded by Mediterranean plantings, multiple sun terraces, and a dining terrace designed for long evenings overlooking the coastline. Inside, the villa combines clean contemporary lines with the warmth of natural materials.\n\nL'Escalet is renowned for its crystal-clear waters and dramatic rocky coastline, offering an exclusive and peaceful atmosphere just 15 minutes from the energy of Saint-Tropez.",
    highlights: [
      "Exclusive L'Escalet location near pristine beaches",
      "Panoramic sea views from pool and terraces",
      "Five private en-suite bedrooms",
      "Minutes from Ramatuelle and Pampelonne",
    ],
    distances: [
      { place: "Plage de l'Escalet", time: "5 min walk" },
      { place: "Pampelonne Beach", time: "10 min drive" },
      { place: "Saint-Tropez Centre", time: "15 min drive" },
      { place: "Nice Airport", time: "95 min drive" },
    ],
  },
  {
    slug: "villa-monroe",
    name: "Villa Monroe",
    location: "L'Escalet, Ramatuelle",
    image: "https://cdn.prod.website-files.com/65c909f4325d487977a8cb32/68ebf0744c3dcff4fe65c3eb_1-Saint%252525252BTropez%252525252BCS-Villas_Villa-Monroe_Swimming-Pool_2_R.avif",
    images: [
      "https://cdn.prod.website-files.com/65c909f4325d487977a8cb32/68ebf0744c3dcff4fe65c3eb_1-Saint%252525252BTropez%252525252BCS-Villas_Villa-Monroe_Swimming-Pool_2_R.avif",
      "https://cdn.prod.website-files.com/65c909f4325d487977a8cb32/68ebf0734c3dcff4fe65c3d7_2-Saint%2BTropez%2BCS-Villas_Villa-Monroe_Sky-view_3_R.avif",
      "https://cdn.prod.website-files.com/65c909f4325d487977a8cb32/68ebf0724c3dcff4fe65c3c8_3-Saint%2BTropez%2BCS-Villas_Villa-Monroe_Sky-view_2_R.avif",
      "https://cdn.prod.website-files.com/65c909f4325d487977a8cb32/68ebf0744c3dcff4fe65c3e8_4-Saint%2BTropez%2BCS-Villas_Villa-Monroe_Sky-view_1_R.avif",
      "https://cdn.prod.website-files.com/65c909f4325d487977a8cb32/68ebf0744c3dcff4fe65c3f7_5-Saint%2BTropez%2BCS-Villas_Villa-Monroe_Swimming-Pool_1_R.avif",
      "https://cdn.prod.website-files.com/65c909f4325d487977a8cb32/68ebf0744c3dcff4fe65c3ee_6-Saint%2BTropez%2BCS-Villas_Villa-Monroe_Terrace_1_R.avif",
    ],
    bedrooms: "5",
    bathrooms: "5",
    guests: "Up to 10",
    pools: "1",
    features: [
      "Heated infinity pool",
      "Sea & sunset views",
      "Open-plan living",
      "Designer furnishings",
      "Air conditioning throughout",
      "Fully equipped kitchen",
      "Outdoor lounge & dining",
      "Sun deck",
      "Mediterranean garden",
      "Private parking",
    ],
    pricing: {
      low: "€22.000",
      high: "€50.000",
    },
    priceNote: "Prices per week. Minimum stay applies during high season.",
    description:
      "Villa Monroe is an architectural gem set in the exclusive L'Escalet area of Ramatuelle, offering five elegant bedrooms with en-suite bathrooms and breathtaking views of the Mediterranean. The heated infinity pool creates a stunning visual connection with the sea beyond.\n\nDesigner interiors feature open-plan living spaces that flow to spacious outdoor terraces, a sun deck, and beautifully landscaped Mediterranean gardens. Every detail has been considered to deliver the ultimate in Riviera luxury.\n\nL'Escalet provides an intimate, secluded setting surrounded by nature, with some of the Côte d'Azur's most beautiful hidden coves just steps away.",
    highlights: [
      "Infinity pool with Mediterranean sea views",
      "Architect-designed contemporary villa",
      "Secluded L'Escalet setting",
      "Close to hidden coves and pristine beaches",
    ],
    distances: [
      { place: "Plage de l'Escalet", time: "5 min walk" },
      { place: "Pampelonne Beach", time: "10 min drive" },
      { place: "Saint-Tropez Centre", time: "15 min drive" },
      { place: "Nice Airport", time: "95 min drive" },
    ],
  },
];
